import React, { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import QuickViewSection from '../../components/QuickViewSection';
import AutoMessageCard from '../AutoMessageCard';

const ClientAutoMessages = ({ clientId, setViewAllType, client, associate_name, merchantId, auth }) => {
  const queryClient = useQueryClient();
  const data = queryClient?.getQueryState(['getAutoMessages', clientId, merchantId], {
    exact: true,
  });

  const refetch = useCallback(() => {
    queryClient.refetchQueries(['getAutoMessages', clientId, merchantId], { exact: true });
  }, [clientId, merchantId, queryClient]);

  return (
    <QuickViewSection
      title="Auto Messages"
      onViewAllClick={
        client?.autoMessages?.length === 0
          ? null
          : () => {
            setViewAllType('allAutoMessages');
          }
      }
      isLoading={data?.isFetching}
      addButton={null}
    >
      {client?.autoMessages?.slice(0, 2)?.map(msg => (
        <AutoMessageCard
          key={msg.id}
          {...msg}
          client_name={msg?.relationship_type_id ? msg?.relation_name || '' : client?.preferred_name || client?.name}
          associate_name={associate_name}
          review_link={''}
          relation={msg?.relationship_type_id ? client?.name : ''}
          client={client}
          auth={auth}
          onDelete={refetch}
        />
      ))}
      {client?.autoMessages?.length === 0 && !data?.isFetching && (
        <div className="flex-col-left">
          <div className="fw-400 fs-12 align-left" style={{ color: '#818181' }}>
            No Auto Messages
          </div>
          <button
            type="button"
            className="blue fs-14 border-none transparent fw-500 align-left"
            style={{ padding: 0, cursor: 'pointer' }}
            onClick={() => {
              setViewAllType('allAutoMessages');
            }}
          >
            VIEW ALL
          </button>
        </div>
      )}
    </QuickViewSection>
  );
};

export default ClientAutoMessages;
